<template lang="pug">
  .navigate
    .no-print.toolbar
      .mobile-title
        span.mobile-title__number.semibold 12
        span Маршруты
      h1.title Навигационный контроль
    .map.absolute(ref="map" v-once)
    .legend.legend_navigate(:class="showMapLegend ? 'opened' : 'closed'" )
      e-perfect-scrollbar
        .legend__head
          .navigate__tabs
            button.reset-btn.legend__title(v-for='tab in tabs' :class="{active:tabView === Object.keys(tab)[0]}" @click="changeTabView(Object.keys(tab)[0])" :key="Object.keys(tab)[0]" ) {{ Object.values(tab)[0] }}
          button.reset-btn.legend__close(v-if="showMapLegend" @click="showMapLegend = false")
          button.reset-btn.legend__open(v-else @click="showMapLegend = true")
        .routes(v-if="tabView === 'routes'")
          .routes__items
            .routes__item.reset-btn(
              v-for='item in routes'
              :key='item.id'
              )
              button.routes__button.reset-btn(@click='getRoute(item.id)')
                span
                  span.routes__prop Рейс №
                  span &nbsp;{{item.id}}
                span
                  span.routes__prop Транспортное средство:
                  span &nbsp;{{item.transport_model}}
                span(v-if="item.driver")
                  span.routes__prop ФИО водителя:
                  span &nbsp;{{item.driver.fio}}
                span
                  span.routes__prop Протяженность:
                  span &nbsp;{{item.route_distance}} км
              .routes__footer
                router-link.routes__link(:to="{ name: 'waybill.waybills.update', params: { id: item.id },query: {prevRoute: prevRoute} }") Редактировать
                button.button.button_warning.reset-btn(@click='deleteRoute(item.id)') Удалить
        navigate-car(v-if="tabView === 'cars'" :map='map')
</template>

<script>
import L from 'leaflet'
import 'leaflet.markercluster'

import { TILE_LAYER } from '@/config/map'
import { REGION_CONFIG } from '@/config/regions'
import BorderDrawer from '@/utils/map/BorderDrawer'
import { msn, transport } from '@/api/api-endpoints'
import OROImage from '@/assets/images/icons/oro.png'
import GarageImage from '@/assets/images/icons/mps.png'
import url from '@/utils/url'
import NavigateCar from './components/navigate-car'

const OROIcon = L.icon({
  iconSize: [30, 30],
  iconUrl: OROImage,
  iconAnchor: [15, 15],
})

const GarageIcon = L.icon({
  iconSize: [30, 30],
  iconUrl: GarageImage,
  iconAnchor: [15, 15],
})

const TIMEOUT_TO_REQUEST = 15000

export default {
  name: 'Navigate',
  components: {
    NavigateCar,
  },
  data: () => ({
    map: null,
    borderDrawer: null,
    routes: null,
    showMapLegend: true,
    routeLayer: null,
    currentRoute: null,
    endPoint: null,
    startPoint: null,
    car: null,
    line: null,
    route: null,
    counterLine: 10,
    carInterval: null,
    tabView: 'routes',
  }),
  computed: {
    tabs() {
      return [{ routes: 'Рейсы' }, { cars: 'Автомобили' }]
    },
    prevRoute() {
      return url.getRoute(this.$route, true)
    },
  },
  methods: {
    getEndpoint(route) {
      return transport.waybills(route)
    },
    async initMap() {
      this.map = L.map(this.$refs.map, {
        center: REGION_CONFIG.map.center,
        zoom: REGION_CONFIG.map.zoom,
        minZoom: REGION_CONFIG.map.minZoom,
        maxZoom: 18,
      })

      L.tileLayer(TILE_LAYER).addTo(this.map)
      this.borderDrawer = new BorderDrawer(this.map, this)
      this.borderDrawer.drawAll(REGION_CONFIG.polygon, [])
    },
    fetchData() {
      this.$bar.start()
      this.$store
        .dispatch('updateUrlEndpoint', {
          endpoint: this.getEndpoint(this.$route),
        })
        .then((data) => {
          this.routes = data.data.data
          this.$bar.finish()
        })
        .catch(() => {
          this.$bar.finish()
        })
    },
    async getRoute(id) {
      this.line = null
      this.counterLine = 10
      this.$bar.start()
      this.route = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: transport.waybill(id),
        })
      ).data
      this.drawRoute(this.route.route.polyline)
      this.drawStartPoint(
        this.route.route.polyline[0],
        this.route.route.start_point_address
      )
      this.line = this.route.route.polyline
      this.drawEndpoint(
        this.route.route.polyline[this.route.route.polyline.length - 1]
      )
      this.counterLine = Math.floor(
        Math.random() * this.route.route.polyline.length - 1
      )
      this.drawCar(this.route.tkoTransport)
      this.moveCar()
      this.$bar.finish()
    },
    clearLayersBeforePaint() {
      if (this.currentRoute) {
        this.routeLayer.removeLayer(this.currentRoute)
      }
      if (this.endPoint) {
        this.routeLayer.removeLayer(this.endPoint)
      }
      if (this.startPoint) {
        this.routeLayer.removeLayer(this.startPoint)
      }
      if (this.car) {
        this.routeLayer.removeLayer(this.car)
      }
    },
    drawRoute(polyline) {
      let passedRoute = []
      this.clearLayersBeforePaint()
      clearInterval(this.carInterval)
      if (polyline && polyline.length > 0) {
        polyline.forEach((v) => {
          passedRoute.push(L.latLng([v[1], v[0]]))
        })
      }
      if (passedRoute.length > 0) {
        this.currentRoute = new L.polyline(passedRoute, {
          color: 'red',
          weight: 3,
          opacity: 0.5,
          smoothFactor: 1,
        })
        this.routeLayer.addLayer(this.currentRoute)
      }
    },
    async getMsns() {
      this.$store.commit('preloader', true)

      const msns = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: msn.containers(
            { query: { 'per-page': -1 } },
            'with_containers'
          ),
        })
      ).data.data
      const msnLayer = L.markerClusterGroup({
        showCoverageOnHover: false,
        iconCreateFunction: (cluster) =>
          L.divIcon({
            className: 'cluster-marker msn',
            html: cluster.getChildCount(),
            iconSize: [36, 36],
            iconAnchor: [18, 18],
          }),
      })
      msns.forEach((item) => {
        if (!item.latitude || !item.longitude) return
        const coords = [item.latitude, item.longitude]
        const myIcon = L.divIcon({
          className: 'my-div-icon',
          html: `<div class='map-icon map-icon_places map-icon_container map-icon-bluegreen'></div>`,
        })
        const marker = L.marker(coords, {
          icon: myIcon,
        })
        marker.bindTooltip(item.name + '<br>' + item.address)
        msnLayer.addLayer(marker)
      })
      this.routeLayer.addLayer(msnLayer)
      this.$store.commit('preloader', false)
    },
    drawEndpoint(coords) {
      this.endPoint = L.marker([coords[1], coords[0]], {
        icon: OROIcon,
      })
      this.routeLayer.addLayer(this.endPoint)
      this.endPoint.bindTooltip(`Конечная точка`)
    },
    drawStartPoint(coords, address) {
      this.startPoint = L.marker([coords[1], coords[0]], {
        icon: GarageIcon,
      })
      this.routeLayer.addLayer(this.startPoint)
      this.startPoint.bindTooltip(`Начальная точка ${address}`)
    },
    async drawCar(data) {
      let coords = this.line[Math.abs(this.counterLine)]

      try {
        const latLon = await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint: transport.track(data.id),
          })
        ).data
        if (latLon && Object.keys(latLon).length > 0) {
          coords = [latLon.lon, latLon.lat]
        }
      } catch (e) {
        this.$notify.warning({
          title: e.data.message,
        })
        clearInterval(this.carInterval)
      }
      if (this.car) {
        this.routeLayer.removeLayer(this.car)
      }

      const className = 'navigate__car-icon'
      const myIcon = L.divIcon({
        className: 'navigate__car',
        iconAnchor: [20, 20],
        html: `<div class='${className}'><span class='navigate__car-point'></span></div>`,
      })
      this.car = L.marker([coords[1], coords[0]], {
        icon: myIcon,
      })
      const popup = L.popup()
      popup.setContent(this.addContentToCarPopup(coords, data))
      this.car.bindPopup(popup)
      this.routeLayer.addLayer(this.car)
    },
    moveCar() {
      this.carInterval = setInterval(() => {
        this.counterLine++
        if (this.counterLine >= this.line.length) {
          // отрицательное значение движение в обратную сторону
          this.counterLine = this.line.length * -1 + 1
        }
        this.drawCar(this.route.tkoTransport)
      }, TIMEOUT_TO_REQUEST)
    },
    addContentToCarPopup(coords, item) {
      return `<div class='map-popup'>
                <div class="map-popup__header">
                    <div class="map-popup__title">${item.brand} ${item.model} ${
        item.number
      }</div>
                </div>
                <div class="map-popup__body">
                     <div class='map-popup__prop semibold'>Координаты:</div>
                     <div class='map-popup__value'>${coords}</div>
                     <div class='map-popup__prop semibold'>Дата и время:</div>
                     <div class='map-popup__value'>${new Date().toLocaleString()}</div>
                </div>
            </div>
        `
    },
    deleteRoute(id) {
      this.confirmBox(
        'Удаленную запись нельзя будет восстановить',
        'Удалить рейс?'
      ).then(() => {
        this.$store.dispatch('deleteModel', {
          url: transport.waybill(id),
          data: { id },
        })
        this.fetchData()
      })
    },
    changeTabView(value) {
      this.tabView = value
      if (value === 'cars') {
        if (this.car) {
          this.routeLayer.removeLayer(this.car)
          clearInterval(this.carInterval)
        }
        if (this.currentRoute) {
          this.routeLayer.removeLayer(this.currentRoute)
        }
        if (this.startPoint) {
          this.routeLayer.removeLayer(this.startPoint)
        }
        if (this.endPoint) {
          this.routeLayer.removeLayer(this.endPoint)
        }
      }
    },
  },
  mounted() {
    this.initMap()
    this.fetchData()
    this.routeLayer = L.featureGroup()
    this.routeLayer.addTo(this.map)
    this.getMsns()
  },
  beforeUnmount() {
    clearInterval(this.carInterval)
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/utils/variables';

.routes {
  &__item {
    border-bottom: 1px solid $grey-true;

    &:not(:last-child) {
      margin-bottom: 15px;
    }
  }

  &__button {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
    padding: 15px;
  }

  &__prop {
    color: $grey-text-color;
  }

  &__link {
    display: block;
    padding: 5px;
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    margin-bottom: 15px;
  }
}
</style>
